export default "__VITE_ASSET__nGZtNRo1__"